import { default as utils } from "../../utils/utils.js"

let lblByDict = (val, type) => {
    if(val == ""){
        return "";
    }
    let tmp = "";
    let dict = utils.getDict(type)
    if(dict instanceof Array){
        dict.forEach((o) => {
            if(o.value == val){
                tmp = o.label
            }
        })
    }
    return tmp
}

let valByDict = (lbl, type) => {
    if(val == ""){
        return "";
    }
    let tmp = "";
    let dict = utils.getDict(type)
    if(dict instanceof Array){
        dict.forEach((o) => {
            if(o.label == lbl){
                tmp = o.value
            }
        })
    }
    return tmp
}

export { lblByDict, valByDict}



// WEBPACK FOOTER //
// ./src/assets/js/dictfilter.js